import { useQuery } from '@tanstack/react-query';
import { entitiesApi } from '@/lib/entities';

/**
 * Pick a real entity instead of typing/handling a raw entity id. Sourced from
 * `entitiesApi.list`. Used by the Entities parent selector and the
 * Consolidation scope selector.
 */
export function EntityPicker({
  wsId,
  value,
  onChange,
  includeNone = false,
  noneLabel = '—',
  excludeId,
  className,
  disabled,
}: {
  wsId: string;
  value: string;
  onChange: (id: string) => void;
  includeNone?: boolean;
  noneLabel?: string;
  excludeId?: string;
  className?: string;
  disabled?: boolean;
}) {
  const { data: entities = [] } = useQuery({
    queryKey: ['entities', wsId],
    queryFn: () => entitiesApi.list(wsId),
    enabled: !!wsId,
  });

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={className ?? 'w-full rounded-md border border-border bg-white px-3 py-2 text-sm'}
    >
      {includeNone && <option value="">{noneLabel}</option>}
      {entities
        .filter((e) => e.id !== excludeId)
        .map((e) => (
          <option key={e.id} value={e.id}>{e.name}{e.currency ? ` · ${e.currency}` : ''}</option>
        ))}
    </select>
  );
}
